import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { actionUrl } from 'config/static-content';

export const testId = 'noAddressFoundTestId';

export const NoAddressFound = () => {
  return (
    <NsAlert state="info" heading="Can’t find your address?" testId={testId}>
      <p>
        If you can&apos;t find your address, please use{' '}
        <NsAnchor href={actionUrl.contact}>live chat</NsAnchor> to get you moved
        in. Our team members are available between Monday to Friday, 8am-8pm and
        Saturday 9am-5pm.
      </p>
    </NsAlert>
  );
};
